import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataRequest, fetchDataSuccess, setInvoiceSettings } from "../../../core/redux/action";
import { Configurations } from "../../../services/internal/configurations";
import ToolsHead from '../../components/toolsHead'
import FormInvoiceConf from "../../components/invoiceConfForm";
import Receipt from "../../components/receipt";
import TokenRefresh from "../../../Router/tokenRefresh";

const InvoiceSettings = () => {

    const invoiceSettings = useSelector((state) => state.invoiceSettings);
    const token = useSelector(state => state.token);
    const dispatch = useDispatch();
    const tokenRefreshRef = useRef(null);
    const contentRef = useRef(null);
    const abortController = new AbortController();

    const onLoadConfiguration = async () => {
        try {
            dispatch(fetchDataRequest());
            const response = await Configurations.getList(token, { name: "Recibo" }, abortController);
            dispatch(setInvoiceSettings(JSON.parse(response.data.data[0]?.value)));
            dispatch(fetchDataSuccess(response.data.success));
        }
        catch (err) {
            if (tokenRefreshRef.current) {
                tokenRefreshRef.current.handleException(err);
            }
        }
    }

    useEffect(() => {
        if (!invoiceSettings) {
            onLoadConfiguration();
        }
    }, [token]);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Configuración de datos del recibo</h4>
                            <h6>Puedes visualizar la configuración que usa el sistema para el contenido de recibos.</h6>
                        </div>
                    </div>
                    <ToolsHead
                        onReload={onLoadConfiguration}
                    />
                </div>
                {invoiceSettings &&
                    <div className="row">
                        <div className="col-lg-8 col-sm-8 col-12 mb-3">
                            <FormInvoiceConf settings={invoiceSettings} />
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="card">
                                <div className="row p-3">
                                    <h4>Ejemplo</h4>
                                </div>
                                <Receipt innerRef={contentRef} saleData={{}} settings={invoiceSettings} />
                            </div>
                        </div>
                    </div>
                }
            </div>
            <TokenRefresh ref={tokenRefreshRef} />
        </div>
    )
}

export default InvoiceSettings
